import React from "react";
import Container from "../helpers/Container";
import "./SectionFilter.scss";
import { reduxForm } from "redux-form";
import {
  fetchJobs,
  filterJobs,
  addLoader,
  removeLoader,
  showMenu,
} from "../../actions";
import { connect } from "react-redux";
import FilterAction from "./FilterIcon";
import MobileSection from "./MobileSection";
import MiscInput from "./MiscInput";
import LocationInput from "./LocationInput";
import FullTimeInput from "./FullTimeInput";

class SectionFilter extends React.Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  onFormSubmit = async (formValues) => {
    this.props.addLoader();
    await this.props.filterJobs(
      formValues.misc,
      formValues.location,
      formValues.fulltime
    );
    this.props.removeLoader();

    if (this.props.menu) {
      this.props.showMenu();
    }
  };

  render() {
    return (
      <section className="section__filter">
        <Container>
          <div className={`header__filter `}>
            <form
              className={`${this.props.darkMode ? "dark--3" : ""}`}
              onSubmit={this.props.handleSubmit(this.onFormSubmit)}
            >
              <MiscInput />
              <LocationInput />
              <FullTimeInput />
              <FilterAction />

              <MobileSection />
            </form>
          </div>
        </Container>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    darkMode: state.darkMode,
    menu: state.menu,
  };
};

export default connect(mapStateToProps, {
  fetchJobs,
  filterJobs,
  addLoader,
  removeLoader,
  showMenu,
})(
  reduxForm({
    form: "SearchJobs",
  })(SectionFilter)
);
